export enum ActionIDs {
    Default,
    Stock,
    MerchantOrders,
    ActiveOrders,
    Deactivated,
    MerchantComplience,
    Country,
    MerchantDocument
  }